import React, { HTMLAttributes, ReactNode } from 'react'

import { cn } from '@frame/lib/utils/cn'
import { PrimitiveDataAttribute } from '@frame/types'

type Props = {
  children: ReactNode
  className?: HTMLAttributes<HTMLSpanElement>['className']
}

export function Span({ children, className }: Props) {
  return (
    <span data-cy={PrimitiveDataAttribute.TW_PRIMITIVE_SPAN} className={cn('font-normal', 'text-moss-700', className)}>
      {children}
    </span>
  )
}
